import { Box, Button, Stack, Typography } from '@mui/material';

import { useGetMyProfileQuery } from '@api/user';

import { style } from './style';

export const NavigationHelp = () => {
  const { data: currentUser } = useGetMyProfileQuery();

  return (
    <Stack spacing={3} sx={style.containerSx}>
      <Box component="img" src="/assets/illustrations/illustration_docs.svg" />

      <Stack spacing={0.5} sx={style.stackSx}>
        <Typography gutterBottom variant="subtitle1">
          {`Hi, ${currentUser?.displayName}`}
        </Typography>

        <Typography variant="body2" sx={style.textSecondarySx}>
          {'Need help?\n Please visit our Help Center'}
        </Typography>
      </Stack>

      <Button
        href="https://receiveddigital.com/help-center/"
        target="_blank"
        rel="noopener"
        variant="contained"
        color="primary"
      >
        Help Center
      </Button>
    </Stack>
  );
}
